import { QuestionWrapper, useFormField, type FieldSchema, type Group } from '@stepform';

export function NzbnField({ fieldSchema, group }: { fieldSchema: FieldSchema; group: Group }) {
  const field = useFormField(fieldSchema, group);

  if (!field.show) {
    return null;
  }

  return (
    <QuestionWrapper {...field} fieldSchema={fieldSchema}>
      <div className="answer-group">
        <div className="answer">
          <input
            type="text"
            className="text"
            value={String(field.answer ?? '')}
            onChange={(e) => field.setAnswer(e.target.value)}
            name={field.question.id}
            id={`input-${field.question.id}`}
          />
        </div>
      </div>
    </QuestionWrapper>
  );
}
